module.exports = __webpack_public_path__ + "img/00052.fc7470a1.webp";